import type Konva from "konva";
import { useEffect } from "react";

import { useHandler } from "~/tools/use-handler";

export interface AttachEventHandlerProps<TNode extends Konva.Node, TName extends keyof GlobalEventHandlersEventMap> {
	node: TNode;
	name: TName;
	handler: Konva.KonvaEventListener<TNode, GlobalEventHandlersEventMap[TName]>;
}

export function AttachEventHandler<TNode extends Konva.Node, TName extends keyof GlobalEventHandlersEventMap>({
	node,
	name,
	handler,
}: AttachEventHandlerProps<TNode, TName>): null {
	const stableHandler = useHandler(handler);

	useEffect(() => {
		node.on(name, stableHandler);

		return () => {
			node.off(name, stableHandler);
		};
	}, [node, name, stableHandler]);

	return null;
}
